import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams, Router } from 'react-router-dom';
import validator from 'validator'
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from '@material-ui/core';
import Header from '../header';
import MaterialTable from 'material-table';
import Top from '../Top';
import { API_URL } from '../../../config';
import { Button, Modal, ModalHeader, ModalBody, Row } from 'reactstrap';




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));

const Viewlinkedlog = ({ serialkeyes }) => {

    const classes = useStyles();

    const [historydata, setHistorydata] = useState([]);
    const [fetchdata, setFetchdata] = useState(true)


    useEffect(() => {
        deviceSevenlinkedhistorylist()
    }, [])


    const deviceSevenlinkedhistorylist = () => {


        fetch(API_URL + "/get/device/seven/linked/list/" + serialkeyes,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    let _temp = [];
                    resp.data.map((v, i) => {
                        _temp.push({
                            user: v.firstname + " " +v.lastname?v.firstname + " " +v.lastname : "No user name",
                            Actions: v.action == 0 ? "Delinked" : "Linked",
                            createdtime: new Date(v.created).toLocaleDateString(),
                           

                        })
                    })
                    setFetchdata(false)
                    setHistorydata(_temp);

                });
            }else if (response.status == 400) {
                setFetchdata(false)
                setHistorydata([]);
                
            }
            
            else {
                console.log("network error")
            }



        })
    }


    const columns = [
        {
            title: "User", field: "user"
        },
        {
            title: "Action", field: "Actions"
        },
        {
            title: "Time", field: "createdtime"
        },

        
    ]

   

    return (
        <div>
            <div style={{ maxWidth: '100%' }}>
            {fetchdata ? <div className='norecordfound'>Fetching record</div> : historydata.length > 0 && <MaterialTable
                    options={{
                        search: true,
                        showTitle: false,
                        toolbar: true,
                        pageSize: 5,
                        pageSizeOptions: [5, 10, 20, 50, 100]
                    }}
                    columns={columns}
                    data={historydata}
                    
                    title=""
                />

            }
                {
                    fetchdata ? "" : historydata.length == 0 && <MaterialTable
                        options={{
                            search: true,
                            showTitle: false,
                            toolbar: true,

                        }}
                        columns={columns}
                        title=""
                    />
                }
               

            </div>
        </div>
    )
}

export default Viewlinkedlog;